import Cookies from 'js-cookie';
import ApiManager from '../api/manager';
import jsonToView from '../api/json-to-view';
import RealTimePrice from './real-time-price';

class SearchProducts {
  constructor() {
    this.config = {
      modules: document.querySelectorAll('[data-module="SearchProducts"]'),
      searchResults: module =>
        module.querySelectorAll('[data-child-module="SearchProducts__Results"]'),
      searchLoader: module =>
        module.querySelectorAll('[data-child-module="SearchProducts__Loader"]'),
      searchLink: module => module.querySelectorAll('[data-child-module="SearchProducts__Link"]'),
      moreResults: module => module.querySelectorAll('[data-module="MoreResults"]'),
      moreResultsContent: (module, type) =>
        module.querySelector(`[data-module="MoreResults__${type}"]`),
      searchTypeButton: module => module.querySelector('[data-module="SearchType"]'),
      apiManager: new ApiManager(),
      searchTypeCookie: 'search-type'
    };
  }

  getSearchLink(module, value) {
    const { productsUrl } = module.dataset;
    value = encodeURIComponent(value);
    const activeSearchType = Cookies.get(this.config.searchTypeCookie);

    const isAi = activeSearchType === 'AI';
    return `${productsUrl || '/producten'}?${isAi ? 'elaiq' : 'elq'}=${value}`;
  }

  displayResults(module, searchString) {
    const {
      apiManager,
      searchResults,
      searchLoader,
      searchLink,
      moreResults,
      moreResultsContent,
      searchTypeButton
    } = this.config;
    const activeSearchType = Cookies.get(this.config.searchTypeCookie);

    const isAi = activeSearchType === 'AI';
    const url = `/api/v2/catalog/elastic/autocomplete?${isAi ? 'elaiq' : 'elq'}=${searchString}`;

    apiManager
      .get(url)
      .then(async response => {
        const searchContainer = module.querySelector(
          '[data-child-module="SearchProducts__Container"]'
        );
        // console.log('rororo', response);

        if (!response) {
          searchContainer.removeAttribute('style');
          searchLoader(module).forEach(el => {
            el.style.display = 'none';
          });

          searchContainer.innerHTML =
            '<p style="margin: 20px">Er is iets mis gegaan met het ophalen van uw zoek resultaten</p>';

          return;
        }
        const data = { ...response };

        data.IsAI = isAi;
        data.SearchTerm = searchString;
        const htmlResponse = await jsonToView(data, 'elAutocomplete');

        if (!htmlResponse) {
          searchContainer.removeAttribute('style');
          searchLoader(module).forEach(el => {
            el.style.display = 'none';
          });

          searchContainer.innerHTML =
            'Er is iets mis gegaan met het ophalen van uw zoek resultaten';

          return;
        }
        // Remove last results
        searchResults(module).forEach(el => {
          el.remove();
        });

        // Suggestion Box

        searchContainer.removeAttribute('style');
        searchLoader(module).forEach(el => {
          el.style.display = 'none';
        });
        searchContainer.innerHTML = htmlResponse;
        searchContainer.childNodes.forEach(node => {
          if (node.nodeName === '#text') {
            node.remove();
          }
        });
        searchContainer.setAttribute('data-search', searchString);

        new RealTimePrice().init();

        const moreResultsElements = moreResults(module);

        moreResultsElements.forEach(el => {
          const { type } = el.dataset;
          const content = moreResultsContent(module, type);

          el.addEventListener('click', () => {
            content.style.display = 'block';
            el.style.display = 'none';
          });
        });

        const button = searchTypeButton(module);

        if (button) {
          button.addEventListener('click', () => {
            const { type } = button.dataset;
            // console.log('rororo ~ SearchProducts ~ displayResults ~ type:', type);
            Cookies.set(this.config.searchTypeCookie, type);
            searchLoader(module).forEach(el => {
              el.removeAttribute('style');
            });

            searchContainer.style.display = 'none';

            this.displayResults(module, searchString);
          });
        }

        // Link
        searchLink(module).forEach(el => {
          el.addEventListener('click', e => {
            e.preventDefault();
            const inputElement = module.querySelector('input');
            if (!inputElement) return;

            const inputValue = inputElement.value;
            if (!inputValue) return;

            window.location.href = this.getSearchLink(module, inputValue);
          });
        });
      })
      // i.p.v. kijken naar statuscode 200 en ready state 4
      .catch(() => {
        searchResults(module).forEach(el => {
          el.remove();
        });
        searchLoader(module).forEach(el => {
          el.removeAttribute('style');
        });
      });
  }

  addInputListeners(searchInput, module) {
    const { searchResults, searchLoader } = this.config;
    let timeout;

    searchInput.addEventListener('input', e => {
      clearTimeout(timeout);
      const searchString = e.target.value;

      if (searchString.length < 2) {
        module.classList.remove('open');
        return;
      }

      // Empty string/only whitespace check
      const regex = /^\s*$/;
      if (regex.test(searchString)) {
        module.classList.remove('open');
        return;
      }

      module.classList.add('open');
      searchLoader(module).forEach(el => {
        el.removeAttribute('style');
      });

      const searchContainer = module.querySelector(
        '[data-child-module="SearchProducts__Container"]'
      );

      searchContainer.style.display = 'none';

      searchResults(module).forEach(el => {
        el.remove();
      });

      timeout = setTimeout(() => this.displayResults(module, searchString), 350);
    });

    searchInput.addEventListener('keydown', e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        module.classList.remove('open');
        const searchValue = searchInput.value;
        if (!searchValue) return;

        window.location.href = this.getSearchLink(module, searchValue);
      }
    });

    module.querySelector('button').addEventListener('click', e => {
      e.preventDefault();
      const searchValue = searchInput.value;
      if (!searchValue) return;
      window.location.href = this.getSearchLink(module, searchValue);
    });
  }

  addFocusListener(searchInput, module) {
    searchInput.addEventListener('focus', e => {
      const searchString = e.target.value;
      if (searchString.length >= 3) {
        module.classList.add('open');
        this.displayResults(module, searchString);
        return;
      }

      module.classList.remove('open');
    });
  }

  addCloseSearchBoxTriggers(module) {
    document.body.addEventListener('click', e => {
      if (module.contains(e.target)) return;
      module.classList.remove('open');
    });
  }

  addEventListeners(module) {
    const searchInput = module.querySelector('input');

    if (!searchInput) return;

    this.addInputListeners(searchInput, module);
    this.addFocusListener(searchInput, module);
    this.addCloseSearchBoxTriggers(module);
  }

  init() {
    const { modules } = this.config;
    modules.forEach(module => {
      this.addEventListeners(module);
    });
  }
}

export default SearchProducts;
